<template>
  <div class="animated fadeIn">
    <transition name="fade">
      <loading v-show="isLoading"></loading>
    </transition>
    <b-modal @close="hideModal" ref="modal-addConfirmation" scrollable centered hide-header-close no-close-on-backdrop>
      <template #modal-title>
        <i class="fas fa-exclamation-triangle"></i> {{ title }}
      </template>
      <p class="warn__subtitle">{{ warnText }}</p>
      <template #modal-footer>
        <div class="w-100 text-right">
          <b-button
            class="btn btn-sm btn-danger rounded-4 ml-2"
            size="sm"
            @click.prevent="hideModal"
          >
            <i class="fas fa-ban"></i><span class="d-md-down-none">&nbsp; Cancelar</span>
          </b-button>

          <button v-if="eventManager"
                  @click.prevent="storeSubmit"
                  type="button"
                  class="btn btn-third btn-sm"
                  v-b-tooltip.hover
                  :title="eventManager.hasNext ? 'Próximo' : 'Salvar'"
          >
            <i :class="eventManager.hasNext ? 'far fa-arrow-alt-circle-right' : 'fas fa-check-circle'"></i>
            <span class="d-md-down-none">&nbsp; {{ eventManager.hasNext ? 'Próximo' : 'Salvar' }}</span>
          </button>
          <b-button v-else
            class="btn btn-sm btn-success rounded-4 ml-2"
            size="sm"
            @click.prevent="onSave"
          >
            <i class="fas fa-check-circle"></i><span class="d-md-down-none">&nbsp; Confirmar</span>
          </b-button>
        </div>
      </template>

    </b-modal>
  </div>
</template>

<script>
import Loading from '@/components/UI/Loading'

import ActionsForm from '@/shared/mixins/actionsForm'

export default {
  name: 'AddConfirmation',
  mixins: [ActionsForm],
  props: {
    saveFunction: {
      type: Function,
      default: null
    },
    warnText: {
      type: String,
      default: ''
    },
    eventManager: {
      type: Object,
      default: null
    }
  },
  components: {
    Loading
  },
  data () {
    return {
      title: 'ATENÇÃO',
      submited: false,
      isLoading: false
    }
  },
  methods: {
    showModal () {
      this.$refs['modal-addConfirmation'].show()
    },
    hideModal () {
      if (!this.submited) this.abort()
      this.$refs['modal-addConfirmation'].hide()
    },
    abort () {
      this.$emit('Abort')
    },
    onSave () {
      this.$emit('Submit')
      this.saveFunction()
      this.$refs['modal-addConfirmation'].hide()
    },
    storeSubmit () {
      let submit = () => this.functionSerasa()
      this.submited = true
      this.$emit('Submit', submit)
    },
    functionSerasa () {
      if (!this.saveFunction) return
      this.saveFunction()
      setTimeout(() => {
        this.isLoading = true
        this.$refs['modal-addConfirmation'].hide()
      }, 300)
    }
  }
}

</script>
<style lang="scss">
.warn{
  &__tittle{
    color: #F00;
    font-size: 1rem;
    font-weight: 600;
  }
  &__subtitle{
    color: #505050;
    font-size: 1rem;
    font-weight: 400;
  }
  hr{
    margin: 1.25rem 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UI/confirmation/addConfirmation.vue